import { render } from "./QuangCao.vue?vue&type=template&id=7d8c1dda&scoped=true"
import script from "./QuangCao.vue?vue&type=script&lang=js"
export * from "./QuangCao.vue?vue&type=script&lang=js"

import "./QuangCao.vue?vue&type=style&index=0&id=7d8c1dda&scoped=true&lang=css"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d8c1dda"]])

export default __exports__